import React, { useMemo } from 'react';
import { useCountdown } from '../hooks/useCountdown';
import { getOfferDeadline } from '../utils/offer';
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}

/** Launch-window countdown: white number tiles for use on navy. */
export function CountdownTimer() {
  const deadline = useMemo(() => getOfferDeadline(), []);
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown(deadline);
  const units = [{
    value: hours,
    label: 'hrs'
  }, {
    value: minutes,
    label: 'min'
  }, {
    value: seconds,
    label: 'sec'
  }];
  if (isExpired) {
    return <p className="text-center font-display text-xl font-bold text-white" data-id="element-63" data-mp="1ad96judp87vx">
        The launch price has ended.
      </p>;
  }
  return <>
      <div className="flex items-center justify-center gap-2 sm:gap-3" aria-hidden="true" data-id="element-64" data-mp="34qrz0psvh0ad">
        {units.map((unit, index) => <React.Fragment key={unit.label} data-id="element-65" data-mp="2zr5m6hgyhm23" data-mpi={index}>
            {index > 0 ? <span className="font-mono text-3xl font-bold text-gold" data-id="element-66" data-mp="2zpkqupmthz36">:</span> : null}
            {/* Styled like a trackside timing clock. */}
            <div className="flex min-w-[80px] flex-col items-center rounded-lg border border-navy-line bg-navy-deep px-3 pb-2 pt-3 sm:min-w-[100px]" data-id="element-67" data-mp="1h0b2mqhrb1zj">
              <span className="font-mono text-4xl font-bold tabular-nums leading-none text-gold sm:text-5xl" data-id="element-68" data-mp="124buxgyk73ux">
                {pad(unit.value)}
              </span>
              <span className="mt-1.5 text-[10px] font-bold uppercase tracking-widest text-muted" data-id="element-69" data-mp="1us7owdwquho0">
                {unit.label}
              </span>
            </div>
          </React.Fragment>)}
      </div>
      <p className="sr-only" role="timer" data-id="element-70" data-mp="1l0bt59i4r3my">
        {hours} hours, {minutes} minutes and {seconds} seconds left at the launch
        price.
      </p>
    </>;
}